if (import.meta.hot) {
  import.meta.hot.accept();
}

const LANGUAGE_SWITCH_PANEL_ID = 'header-language-nav-panel';
// Keeps multiform state (e.g. the trainingregistration teaser/location prefill) across a
// language switch. These params only ever appear on pages with a multiform content element,
// so this is a no-op everywhere else.
const PRESERVED_QUERY_PARAMS = ['topic', 'location', 'productgroup'];

// The multiform teaser switch updates the URL client-side via history.replaceState, so the
// language links (rendered once server-side) would otherwise still point at the initial state.
// Recomputing them right before the panel opens covers both that case and a normal page load.
document.addEventListener('sidebar:beforeopen', (event) => {
  if (event.detail?.id !== LANGUAGE_SWITCH_PANEL_ID) return;

  const currentParams = new URLSearchParams(window.location.search);
  document.querySelectorAll(`#${LANGUAGE_SWITCH_PANEL_ID} .header__language-nav-link[href]`).forEach((link) => {
    const url = new URL(link.getAttribute('href'), window.location.href);
    PRESERVED_QUERY_PARAMS.forEach((param) => {
      const value = currentParams.get(param);
      if (value !== null) {
        url.searchParams.set(param, value);
      }
    });
    link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
  });
});

document.querySelectorAll('[data-language-switch]').forEach((root) => {
  const select = root.querySelector('[data-language-switch-region] select');
  if (!select) return;
  select.addEventListener('change', () => {
    root.querySelectorAll('[data-language-switch-region-list]').forEach((nav) => {
      nav.hidden = nav.dataset.languageSwitchRegionList !== select.value;
    });
  });
});
